import { Component, OnInit, Input } from '@angular/core';
import { DayData, ImputationsData } from './calendar-day.model';

@Component({
  selector: 'app-calendar-day',
  templateUrl: './calendar-day.component.html',
  styleUrls: ['./calendar-day.component.scss']
})
export class CalendarDayComponent implements OnInit {
  @Input() dia: DayData;
  imputationsS1 = [];
  imputationsS2 = [];
  imputationsS3 = [];
  public infoImputation: ImputationsData;
  public date: Date;

  constructor() {}

  ngOnInit(): void {
    this.dia.imputations.forEach(element => {
      if (element.activityTypeId === '1') {
        this.imputationsS1.push(element);
      }
      if (element.activityTypeId === '2') {
        this.imputationsS2.push(element);
      }
      if (element.activityTypeId === '3') {
        this.imputationsS3.push(element);
      }
    });

    this.date = new Date(this.getYear(), this.getMonth(), this.getDay());
  }

  private getDay(): number {
    return Number(this.dia.date.substring(6, 8));
  }

  private getMonth(): number {
    return Number(this.dia.date.substring(4, 6)) - 1;
  }

  private getYear(): number {
    return Number(this.dia.date.substring(0, 4));
  }
}
